import { render, staticRenderFns } from "./ManagePlan.vue?vue&type=template&id=12c37fe2&"
import script from "./ManagePlan.vue?vue&type=script&lang=js&"
export * from "./ManagePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports